import {
  TYPE_PERSONNE
} from '../modules/accueil/model';
import { NATURE_PERTURBATION, PERMANENT_ALEATOIRE } from '../modules/common/model';
import {
  $qProvider
} from '../providers';
import { deburr } from 'lodash';
import MessageRepository from '../repositories/message.repository';
import AntenneRepository from '../repositories/antenne.repository';
import ReclamationPrtvRepository from '../repositories/reclamation-prtv.repository';
import ReclamationLteRepository from '../repositories/reclamation-lte.repository';
import AdresseRepository from '../repositories/apiadressedatagouv.repository';
import SuivieDossierRepository from '../repositories/suivie-dossier.repository';
//TODO: Ajouter le call a l'API Brouillage
//import webserviceLteRepository from '../repositories/webservice-lte.repository';

import DemandeUtil from '../utils/demande.util';

import filter from 'lodash/filter';
import some from 'lodash/some';
import defaultsDeep from 'lodash/defaultsDeep';

const ACCUEIL_INTERFACE_1 = 'accueil-interface-1';
const ACCUEIL_INTERFACE_2 = 'accueil-interface-2';
const ACCUEIL_INTERFACE_3 = 'accueil-interface-3';
const ETAT_CHAINES = 'etat-chaines';
const REAMENAGEMENT = 'reamenagement';
const ANTENNE_ACCESSIBLE = 'antenne-accessible';
const FIN_ACCUEIL = 'fin-accueil';
const INTERVENTION_ANTENNISTE = 'intervention-antenniste';
const SIGNALEMENT_ANTENNISTE = 'signalement-antenniste';
const DYSFONCTIONNEMENT_INTERFACE = 'dysfonctionnement-interface';
const INCIDENT_DETECTE = 'incident-detecte';
const AUCUN_INCIDENT_DETECTE = 'aucun-incident-detecte';
const CONCLUSION = 'conclusion';
const HOME = 'home';
const ZONE_PERTURBE = 'zone-perturbe';
const CONTACT = 'contact';
const CONSTAT = 'constat';
const FIN_ANTENNISTE = 'fin-antenniste';

const PRTV_INTERFACE_1 = 'prtv-interface-1';
const PRTV_INTERFACE_2 = 'prtv-interface-2';
const PRTV_INTERFACE_3 = 'prtv-interface-3';
const PRTV_INTERFACE_4 = 'prtv-interface-4';
const PRTV_INTERFACE_5 = 'prtv-interface-5';
const PRTV_INTERFACE_6 = 'prtv-interface-6';
const PRTV_DEPOT_FACTURE = 'prtv-depot-facture';
const PRTV_DEPOT_FACTURE_2 = 'prtv-depot-facture-2';
const PRTV_DEPOT_FACTURE_3 = 'prtv-depot-facture-3';

const LTE_INTERFACE_1 = 'lte-interface-1';
const LTE_INTERFACE_2 = 'lte-interface-2';
const SUIVIE_AUTHENT = 'suivie-authent';
const SUIVIE_RESULTAT = 'suivie-resultat';
const FROM_RECLAMATION = 'from_reclamation';
const STEPS = {
  ACCUEIL_INTERFACE_1: ACCUEIL_INTERFACE_1,
  ACCUEIL_INTERFACE_2: ACCUEIL_INTERFACE_2,
  ACCUEIL_INTERFACE_3: ACCUEIL_INTERFACE_3,
  ETAT_CHAINES: ETAT_CHAINES,
  REAMENAGEMENT: REAMENAGEMENT,
  ANTENNE_ACCESSIBLE: ANTENNE_ACCESSIBLE,
  INTERVENTION_ANTENNISTE: INTERVENTION_ANTENNISTE,
  SIGNALEMENT_ANTENNISTE: SIGNALEMENT_ANTENNISTE,
  FIN_ACCUEIL: FIN_ACCUEIL,
  DYSFONCTIONNEMENT_INTERFACE: DYSFONCTIONNEMENT_INTERFACE,
  INCIDENT_DETECTE: INCIDENT_DETECTE,
  AUCUN_INCIDENT_DETECTE: AUCUN_INCIDENT_DETECTE,
  CONCLUSION: CONCLUSION,
  HOME: HOME,
  ZONE_PERTURBE: ZONE_PERTURBE,
  CONTACT: CONTACT,
  CONSTAT: CONSTAT,
  FIN_ANTENNISTE: FIN_ANTENNISTE,
  PRTV_INTERFACE_1: PRTV_INTERFACE_1,
  PRTV_INTERFACE_2: PRTV_INTERFACE_2,
  PRTV_INTERFACE_3: PRTV_INTERFACE_3,
  PRTV_INTERFACE_4: PRTV_INTERFACE_4,
  PRTV_INTERFACE_5: PRTV_INTERFACE_5,
  PRTV_INTERFACE_6: PRTV_INTERFACE_6,
  PRTV_DEPOT_FACTURE: PRTV_DEPOT_FACTURE,
  PRTV_DEPOT_FACTURE_2: PRTV_DEPOT_FACTURE_2,
  PRTV_DEPOT_FACTURE_3: PRTV_DEPOT_FACTURE_3,
  LTE_INTERFACE_1: LTE_INTERFACE_1,
  LTE_INTERFACE_2: LTE_INTERFACE_2,
  SUIVIE_AUTHENT: SUIVIE_AUTHENT,
  SUIVIE_RESULTAT: SUIVIE_RESULTAT
};

function validateDemandeForStep(demande, step) {
  switch (step) {
  case ACCUEIL_INTERFACE_1:
    // Pas de contraintes sur la demande
    return demande.typePersonne !== TYPE_PERSONNE.PROFESSIONNEL_RECEPTION;
  case ACCUEIL_INTERFACE_2:
    if (demande.typePersonne === TYPE_PERSONNE.PROFESSIONNEL_RECEPTION) {
      return validateDemandeForStep(demande, HOME);
    }
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_1) && demande.accueilInterface1;
  case ACCUEIL_INTERFACE_3:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case INCIDENT_DETECTE:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case AUCUN_INCIDENT_DETECTE:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case ETAT_CHAINES:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case CONCLUSION:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case REAMENAGEMENT:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case ANTENNE_ACCESSIBLE:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case FIN_ACCUEIL:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case INTERVENTION_ANTENNISTE:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case SIGNALEMENT_ANTENNISTE:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case PRTV_INTERFACE_1:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2) && demande.numeroAnfr;
  case DYSFONCTIONNEMENT_INTERFACE:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case LTE_INTERFACE_1:
    if (demande.signalementAntenniste && demande.signalementAntenniste.antennes) {
      return validateDemandeForStep(demande, SIGNALEMENT_ANTENNISTE);
    } else if (demande.dysfonctionnementInterface && demande.dysfonctionnementInterface.antennes) {
      return validateDemandeForStep(demande, DYSFONCTIONNEMENT_INTERFACE);
    }
    break;
  case LTE_INTERFACE_2:
    return validateDemandeForStep(demande, LTE_INTERFACE_1) && demande.numeroAnfr;
  case PRTV_INTERFACE_2:
    if (demande.numeroAnfr === (demande.suivieAuthent ? demande.suivieAuthent.identifiant : '')) {
      return validateDemandeForStep(demande, SUIVIE_AUTHENT) && demande.numeroAnfr;
    }
    return validateDemandeForStep(demande, PRTV_INTERFACE_1) && demande.numeroAnfr;
  case PRTV_INTERFACE_3:
    return validateDemandeForStep(demande, PRTV_INTERFACE_2) && demande.numeroAnfr;
  case PRTV_INTERFACE_4:
    return validateDemandeForStep(demande, PRTV_INTERFACE_3) && demande.numeroAnfr;
  case PRTV_INTERFACE_5:
    return validateDemandeForStep(demande, PRTV_INTERFACE_4) && demande.numeroAnfr;
  case PRTV_INTERFACE_6:
    return validateDemandeForStep(demande, PRTV_INTERFACE_5) && demande.numeroAnfr;
  case PRTV_DEPOT_FACTURE:
    if (demande.numeroAnfr === (demande.suivieAuthent ? demande.suivieAuthent.identifiant : '')) {
      return validateDemandeForStep(demande, SUIVIE_AUTHENT) && demande.numeroAnfr;
    } else {
      return validateDemandeForStep(demande, PRTV_INTERFACE_6) && demande.numeroAnfr;
    }
    break;
  case PRTV_DEPOT_FACTURE_2:
    return validateDemandeForStep(demande, PRTV_DEPOT_FACTURE) && demande.numeroAnfr;
  case PRTV_DEPOT_FACTURE_3:
    return validateDemandeForStep(demande, PRTV_DEPOT_FACTURE_2) && demande.numeroAnfr;
  case CONTACT:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case ZONE_PERTURBE:
    return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
  case CONSTAT:
    return validateDemandeForStep(demande, CONTACT);
  case FIN_ANTENNISTE:
    return validateDemandeForStep(demande, CONSTAT);
  case SUIVIE_AUTHENT:
    // Pas de contraintes sur la demande
    return demande.suivieAuthent;
  case SUIVIE_RESULTAT:
    return validateDemandeForStep(demande, SUIVIE_AUTHENT);
  default:
    // Par défaut on doit avoir un objet demande
    return !!demande;
}
}

function nextStep(demande, currentStep) {
  switch (currentStep) {
  case HOME:
    if (demande.suivieAuthent) {
      return $qProvider().when({
        step: SUIVIE_AUTHENT
      });
    } else {
      if (demande.typePersonne === TYPE_PERSONNE.PROFESSIONNEL_RECEPTION) {
        return $qProvider().when({
          step: ACCUEIL_INTERFACE_2
        });
      }
      return $qProvider().when({
        step: ACCUEIL_INTERFACE_1
      });
    }
    return;
  case ACCUEIL_INTERFACE_1:
    return $qProvider().when({
      step: ACCUEIL_INTERFACE_2
    });
  case ACCUEIL_INTERFACE_2:
    if (demande.typePersonne === TYPE_PERSONNE.PROFESSIONNEL_RECEPTION) {
      return handleAccueilInterface2Antenniste(demande, true);
    }
    return searchReamenagement(demande, true);
  case ACCUEIL_INTERFACE_3:
    if (demande.typePersonne === TYPE_PERSONNE.PROFESSIONNEL_RECEPTION) {
      return handleAccueilInterface3Antenniste(demande);
    }
    return searchReamenagement(demande, false);
  case REAMENAGEMENT:
    if (demande.reamenagement.source === 'fin') {
      return $qProvider().when({
        step: CONCLUSION
      });
    }
    return handleAccueilInterface2NextStep(demande, false);
  case ANTENNE_ACCESSIBLE:
    return handleAntenneAccessibleNextStep(demande);
  case INTERVENTION_ANTENNISTE:
    return handleInterventionAntennisteNextStep(demande);
  case SIGNALEMENT_ANTENNISTE:
    return handleSignalementAntennisteNextStep(demande);
  case DYSFONCTIONNEMENT_INTERFACE:
    return handleDysfonctionnementInterfaceNextStep(demande);
  case FIN_ACCUEIL:
    return $qProvider().when({
      step: HOME
    });
  case ETAT_CHAINES:
    return handleEtatChainesNextStep(demande);
  case AUCUN_INCIDENT_DETECTE:
    if (demande.aucunIncidentDetecte.continuerPrtv === true) {
      let insert = null;
      if (demande.numeroAnfr) {
        insert = preUpdatePrtv(demande, DemandeUtil.demandeToPrtv(demande));
      } else {
        insert = prePostPrtv(demande, DemandeUtil.demandeToPrtv(demande));
      }
      // on envoie tjrs une promesse
      return insert.then(result => {
        demande.numeroAnfr = result.numeroAnfr;
        demande.checkCode = result.checkCode;
        return {
          step: PRTV_INTERFACE_1,
          updatedDemande: demande
        };
      });
    }
    // Ne devrait pas arriver, on renvoie vers la première page
    return $qProvider().when({
      step: CONCLUSION
    });
  case INCIDENT_DETECTE:
    //  update ou poste suivant si on a un numero anfr ou pas
    let insert = null;
    if (demande.numeroAnfr) {
      insert = preUpdatePrtv(demande, DemandeUtil.demandeToPrtv(demande));
    } else {
      insert = prePostPrtv(demande, DemandeUtil.demandeToPrtv(demande));
    }
    if (demande.incidentDetecte.continuerPrtv === true) {
      // on envoie tjrs une promesse
      return insert.then(result => {
        demande.numeroAnfr = result.numeroAnfr;
        demande.checkCode = result.checkCode;
        return {
          step: PRTV_INTERFACE_1,
          updatedDemande: demande
        };
      });
    }
    return insert.then(result => {
      demande.numeroAnfr = result.numeroAnfr;
      demande.checkCode = result.checkCode;
      return {
        step: CONCLUSION,
        updatedDemande: demande
      };
    });
  case ZONE_PERTURBE:
    if (demande.zonePerturbe.source === 'oui') {
      return $qProvider().when({
        step: CONTACT
      });
    }
    return $qProvider().when({
      step: CONCLUSION
    });
  case CONTACT:
    return $qProvider().when({
      step: CONSTAT
    });
  case FIN_ANTENNISTE:
    return $qProvider().when({
      step: HOME
    });
  case CONSTAT:
    return postPrtvAntenniste(demande, DemandeUtil.demandeAntennisteToPrtv(demande));
  case LTE_INTERFACE_1:
    return postLte(demande, DemandeUtil.demandeToLte(demande));
  case LTE_INTERFACE_2:
    return $qProvider().when({
      step: HOME
    });
  case CONCLUSION:
    return $qProvider().when({
      step: HOME
    });
  case PRTV_INTERFACE_1:
    return updatePrtvFirstStep(demande, DemandeUtil.demandeToPrtv(demande));
  case PRTV_INTERFACE_2:
    if (demande.prtvInterface2.demandeEnquetePapier) {
      return $qProvider().when({
        step: PRTV_INTERFACE_3
      });
    } else {
      return $qProvider().when({
        step: HOME
      });
    }
    break;
  case PRTV_INTERFACE_3:
    return $qProvider().when({
      step: PRTV_INTERFACE_4
    });
  case PRTV_INTERFACE_4:
    return $qProvider().when({
      step: PRTV_INTERFACE_5
    });
  case PRTV_INTERFACE_5:
    return updatePrtvupdateReclamationDemandeEnquete(demande, DemandeUtil.demandeToPrtvDemandeEnquete(demande));
  case PRTV_INTERFACE_6:
    return checkFactureDossier(demande);
  case PRTV_DEPOT_FACTURE:
    return $qProvider().when({
      step: PRTV_DEPOT_FACTURE_2
    });
  case PRTV_DEPOT_FACTURE_2:
    return updateDossierWithAntenniste(demande, DemandeUtil.demandeAvecFactureDemandeEnquete(demande));
  case PRTV_DEPOT_FACTURE_3:
    return $qProvider().when({
      step: HOME
    });
  case SUIVIE_AUTHENT:
    return checkDossier(demande);
  case SUIVIE_RESULTAT:
    return $qProvider().when({
      step: HOME
    });
  default:
    return $qProvider().when({
      step: HOME
    });
}
}

function checkFactureDossier(demande) {
  return SuivieDossierRepository.checkFactureDossier(demande)
    .then(result => {
      if (result.data.codeStatut === 'PRTV_DE_EN_COURS_SAISIE_PAR_LE_TSP') {
        return {
          step: PRTV_DEPOT_FACTURE,
          updatedDemande: defaultsDeep({
            numeroAnfr: result.data.numeroAnfr,
            codeStatut: result.data.codeStatut,
            demandeEnquete: result.data.demandeEnquete,
            typePersonne: result.data.typePersonne,
            checkCode: result.data.checkCode,
          }, demande)
        };
      }
    });
}

function checkDossier(demande) {
  return SuivieDossierRepository.checkDossier(demande)
    .then(result => {
      if (result.data.codeStatut === 'PRTV_DE_EN_COURS_SAISIE_PAR_LE_TSP') {
        return {
          step: PRTV_DEPOT_FACTURE,
          updatedDemande: defaultsDeep({
            numeroAnfr: result.data.numeroAnfr,
            codeStatut: result.data.codeStatut,
            demandeEnquete: result.data.demandeEnquete,
            typePersonne: result.data.typePersonne,
            checkCode: result.data.checkCode,
            informationsSuivi: result.data.informationsSuivi
          }, demande)
        };
      }
      if (result.data.codeStatut === 'PRTV_DE_NOM_ENREGISTRE') {
        return {
          step: PRTV_INTERFACE_2,
          updatedDemande: defaultsDeep({
            numeroAnfr: result.data.numeroAnfr,
            codeStatut: result.data.codeStatut,
            demandeEnquete: result.data.demandeEnquete,
            typePersonne: result.data.typePersonne,
            checkCode: result.data.checkCode,
            informationsSuivi: result.data.informationsSuivi
          }, demande)
        };
      }
      return {
        step: SUIVIE_RESULTAT,
        updatedDemande: defaultsDeep({
          suivieResultat: result.data
        }, demande)
      };
    });
}

function updateDossierWithAntenniste(demande, demandePrtv) {
  return ReclamationPrtvRepository.updateReclamationDemandeFacture(demandePrtv)
    .then(result => {
      return {
        step: PRTV_DEPOT_FACTURE_3,
        updatedDemande: defaultsDeep({
          numeroAnfr: result.data.numeroAnfr,
          codeStatut: result.data.codeStatut
        }, demande)
      };
    });
}

function postLte(demande, demandeLte) {
  return ReclamationLteRepository.postReclamation(demandeLte)
    .then(result => {
      return {
        step: LTE_INTERFACE_2,
        updatedDemande: defaultsDeep({
          numeroAnfr: result.data.numeroAnfr
        }, demande)
      };
    });
}

function postPrtvAntenniste(demande, demandePrtv) {
  return ReclamationPrtvRepository.postReclamation(demandePrtv)
    .then(result => {
      return {
        step: FIN_ANTENNISTE,
        updatedDemande: defaultsDeep({
          numeroAnfr: result.data.numeroAnfr
        }, demande)
      };
    });
}

// post au milieu de script
function prePostPrtv(demande, demandePrtv) {
  return ReclamationPrtvRepository.postReclamation(demandePrtv)
    .then(result => {
      return {
        numeroAnfr: result.data.numeroAnfr,
        checkCode: result.data.checkCode
      };
    });
}
//methode appelé en update au milieu de script
function preUpdatePrtv(demande, demandePrtv) {
  return ReclamationPrtvRepository.updateReclamation(demandePrtv)
    .then(result => {
      return {
        numeroAnfr: result.data.numeroAnfr,
        checkCode: result.data.checkCode
      };
    });
}

function updatePrtvFirstStep(demande, demandePrtv) {
  return ReclamationPrtvRepository.updateReclamation(demandePrtv)
    .then(result => {
      return {
        step: PRTV_INTERFACE_2,
        updatedDemande: defaultsDeep({
          numeroAnfr: result.data.numeroAnfr
        }, demande)
      };
    });
}

function updatePrtvupdateReclamationDemandeEnquete(demande, demandePrtv) {
  return ReclamationPrtvRepository.updateReclamationDemandeEnquete(demandePrtv)
    .then(result => {
      return {
        step: PRTV_INTERFACE_6,
        updatedDemande: defaultsDeep({
          numeroAnfr: result.data.numeroAnfr
        }, demande)
      };
    });
}

function searchReamenagement(demande, checkAdresse) {
  let objetAdresse;
  let codeDepCom = Array('975', '977', '978', '986', '987', '988');
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }

  const nomCommune = renameStCommuneShortName(objetAdresse.commune.nom);
  const insee = objetAdresse.commune.insee.substring(0, 3);

  if (codeDepCom.indexOf(insee) !== -1) { // Filtre sur les COM
    return handleAccueilInterface2NextStep(demande, checkAdresse);
  } else {
    if (checkAdresse) {
      const adresseSaisie = `${objetAdresse.numero || ''} ${unminifyNameVoie(objetAdresse.voie)} ${objetAdresse.codePostal.codepostal} ${nomCommune}`;
      // on contrôle l'adresse
      return AdresseRepository.getAdresseApiDataGouv(adresseSaisie)
        .then((adresses) => {
          if ((adresses.length > 0) && checkAdresseValid(`${objetAdresse.numero || ''} ${objetAdresse.voie}`, adresses[0].properties.score)) {
            // Normalisation du nom de voie
            demande = defaultsDeep({
              voieShort: normalizeAdresseVoie(adresses[0].properties)
            }, demande);

            const adresse = `${objetAdresse.numero || ''} ${demande.voieShort} ${objetAdresse.codePostal.codepostal} ${nomCommune}`;
            return AntenneRepository.getReamenagement(adresse, objetAdresse.commune.nom)
              .then((result) => {
                //On vérifie si y'a un objet dans le multiArray
                if (result.data.multiArray.length > 0) {
                  return $qProvider().when({
                    step: REAMENAGEMENT,
                    updatedDemande: defaultsDeep({
                      reamenagement: {
                        phases: result.data
                      }
                    }, demande)
                  });
                }
                return handleAccueilInterface2NextStep(demande, false);
              });
          } else {
            demande = defaultsDeep({
              voieShort: demande.accueilInterface2.adresse.voie
            }, demande);
            return $qProvider().when({
              step: ACCUEIL_INTERFACE_3,
              updatedDemande: defaultsDeep(demande)
            });
          }
        });
    } else {
      const adresse = `${objetAdresse.numero || ''} ${demande.voieShort} ${objetAdresse.codePostal.codepostal} ${nomCommune}`;
      return AntenneRepository.getReamenagement(adresse, objetAdresse.commune.nom)
        .then((result) => {
          //On vérifie si y'a un objet dans le multiArray
          if (result.data.multiArray.length > 0) {
            return $qProvider().when({
              step: REAMENAGEMENT,
              updatedDemande: defaultsDeep({
                reamenagement: {
                  phases: result.data
                }
              }, demande)
            });
          }
          return handleAccueilInterface2NextStep(demande, false);
        });
    }
  }
}

function handleAccueilInterface2NextStep(demande, checkAdresse) {
  const multiplex = demande.accueilInterface2.multiplex;
  const chaines = demande.accueilInterface2.chaines;
  const muxConcernes = filter(multiplex, (m) => m.chainesActives.length && some(m.chainesActives, (c) => some(chaines, (c2) => c.id === c2.id)));

  let objetAdresse;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  const codeInsee = objetAdresse.commune.insee;
  const nomCommune = renameStCommuneShortName(objetAdresse.commune.nom);

  // on contrôle l'adresse
  if (checkAdresse) {
    const adresseSaisie = `${objetAdresse.numero || ''} ${unminifyNameVoie(objetAdresse.voie)} ${objetAdresse.codePostal.codepostal} ${nomCommune}`;
    return AdresseRepository.getAdresseApiDataGouv(adresseSaisie)
      .then((adresses) => {
        if ((adresses.length > 0) && checkAdresseValid(`${objetAdresse.numero || ''} ${objetAdresse.voie}`, adresses[0].properties.score)) {
          // Normalisation du nom de voie
          demande = defaultsDeep({
            voieShort: normalizeAdresseVoie(adresses[0].properties)
          }, demande);
          const adresse = `${objetAdresse.numero || ''} ${demande.voieShort} ${objetAdresse.codePostal.codepostal} ${nomCommune}`;
          // renvoie vers la page etat chaine
          return redirectToETatChaine(codeInsee, adresse, muxConcernes, demande);
        } else {
          demande = defaultsDeep({
            voieShort: demande.accueilInterface2.adresse.voie
          }, demande);
          return $qProvider().when({
            step: ACCUEIL_INTERFACE_3,
            updatedDemande: defaultsDeep(demande)
          });
        }
      });
  } else {
    const adresse = `${objetAdresse.numero || ''} ${demande.voieShort} ${objetAdresse.codePostal.codepostal} ${nomCommune}`;
    // renvoie vers la page etat chaine
    return redirectToETatChaine(codeInsee, adresse, muxConcernes, demande);
  }
}

function redirectToETatChaine(codeInsee, adresse, muxConcernes, demande) {
  //On ne vérifie plus si on au moins un antenne
  return $qProvider().when({
    step: ETAT_CHAINES,
    updatedDemande: demande
  });
}

function handleAccueilInterface3Antenniste(demande) {
  return handleAccueilInterface2Antenniste(demande, false);
}

function checkAdresseValid(adresse, score) {
  // Valide l'adresse en fonction du score et de la longueur de l'adresse
  let resultat = false;
  let scoreMin = 0.55;

  if (adresse.length > 15) {
    scoreMin = 0.65;
  }

  if (adresse.length > 20) {
    scoreMin = 0.7;
  }

  if (adresse.length > 25) {
    scoreMin = 0.75;
  }

  if (adresse.length > 30) {
    scoreMin = 0.8;
  }

  if (score >= scoreMin) {
    resultat = true;
  }

  return resultat;
}

function handleAccueilInterface2Antenniste(demande, checkAdresse) {
  const multiplex = demande.accueilInterface2.multiplex;
  const chaines = demande.accueilInterface2.chaines;
  const muxConcernes = filter(multiplex, (m) => m.chainesActives.length && some(m.chainesActives, (c) => some(chaines, (c2) => c.id === c2.id)));

  let objetAdresse;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  const codeInsee = objetAdresse.commune.insee;

  // on contrôle l'adresse
  if (checkAdresse) {
    const nomCommune = renameStCommuneShortName(objetAdresse.commune.nom);
    const adresse = `${objetAdresse.numero || ''} ${unminifyNameVoie(objetAdresse.voie)} ${objetAdresse.codePostal.codepostal} ${nomCommune}`;
    return AdresseRepository.getAdresseApiDataGouv(adresse)
      .then((adresses) => {
        if ((adresses.length > 0) && checkAdresseValid(`${objetAdresse.numero || ''} ${objetAdresse.voie}`, adresses[0].properties.score)) {
          // Normalisation du nom de voie
          demande = defaultsDeep({
            voieShort: normalizeAdresseVoie(adresses[0].properties)
          }, demande);
          // Vérification de la présence d'un message pour la commune
          return MessageRepository.getMessageCommune(codeInsee)
            .then((messages) => {
              const messageFound = getMessagePourAuMoins(messages.data, muxConcernes, muxConcernes.length);
              if (messageFound) {
                return $qProvider().when({
                  step: ZONE_PERTURBE,
                  updatedDemande: defaultsDeep({
                    zonePerturbe: {
                      message: messageFound
                    }
                  }, demande)
                });
              }
              return $qProvider().when({
                step: CONTACT,
                updatedDemande: defaultsDeep({
                  contact: {}
                }, demande)
              });
            });
        } else {
          demande = defaultsDeep({
            voieShort: demande.accueilInterface2.adresse.voie
          }, demande);
          return $qProvider().when({
            step: ACCUEIL_INTERFACE_3,
            updatedDemande: defaultsDeep(demande)
          });
        }
      });
  } else {
    // Vérification de la présence d'un message pour la commune
    return MessageRepository.getMessageCommune(codeInsee)
      .then((messages) => {
        const messageFound = getMessagePourAuMoins(messages.data, muxConcernes, muxConcernes.length);
        if (messageFound) {
          return $qProvider().when({
            step: ZONE_PERTURBE,
            updatedDemande: defaultsDeep({
              zonePerturbe: {
                message: messageFound
              }
            }, demande)
          });
        }
        return $qProvider().when({
          step: CONTACT,
          updatedDemande: defaultsDeep({
            contact: {}
          }, demande)
        });
      });
  }
}

function handleAntenneAccessibleNextStep(demande) {
  // Si oui, on passe a la question suivante
  if (demande.antenneAccessible.source) {
    return $qProvider().when({
      step: INTERVENTION_ANTENNISTE,
      updatedDemande: defaultsDeep({
        antenneAccessible: {
          source: demande.antenneAccessible.source
        }
      }, demande)
    });
  } // si  non, fin du processus
  return $qProvider().when({
    step: FIN_ACCUEIL,
    updatedDemande: defaultsDeep({
      antenneAccessible: {
        source: demande.antenneAccessible.source
      }
    }, demande)
  });
}

function handleDysfonctionnementInterfaceNextStep(demande) {
  demande.defaultSuspicionLte = false;
  //si c'est un brouillage
  let objetAdresse;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  const codeInsee = objetAdresse.commune.insee;
  const adresseStruct = deburr(`${objetAdresse.numero || ''} ${objetAdresse.voie} ${objetAdresse.codePostal.codepostal} ${objetAdresse.commune.nom}`);
  // Si permanent
  if (demande.dysfonctionnementInterface.natureDysfonctionnement === PERMANENT_ALEATOIRE.PERMANENT) {
    // appel au rayon par defaut.
    return AntenneRepository
    .getAntenneLTEPerturbation(codeInsee, adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 'commune_defaut')
    .then((antennes) => {
      if (antennes.total > 0) {
        return $qProvider().when({
          step: LTE_INTERFACE_1,
          updatedDemande: defaultsDeep({
            dysfonctionnementInterface: {
              antennes: antennes,
            }
          }, demande)
        });
      } else {
        //appel pour avoir la perturbation lte et savoir si c'est un PRTV risque LTE ou non
        let objetAdresse;
        if (demande.accueilInterface2.adresse) {
          objetAdresse = demande.accueilInterface2.adresse;
        }
        const codeInsee = objetAdresse.commune.insee;
        const adresseStruct = deburr(`${objetAdresse.numero || ''} ${objetAdresse.voie} ${objetAdresse.codePostal.codepostal}
         ${objetAdresse.commune.nom}`);
        // appel LTE a 3km
        return AntenneRepository
        .getAntenneLTEPerturbation(codeInsee, adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 3000)
        .then((antennes) => {
          if (antennes.total > 0) {
            return $qProvider().when({
              step: LTE_INTERFACE_1,
              updatedDemande: defaultsDeep({
                dysfonctionnementInterface: {
                  antennes: antennes,
                }
              }, demande)
            });
          } else {
            demande.defaultSuspicionLte = false;
          }
          //save/update et go to PRTV
          let insert = null;
          if (demande.numeroAnfr) {
            insert = preUpdatePrtv(demande, DemandeUtil.demandeToPrtv(demande));
          } else {
            insert = prePostPrtv(demande, DemandeUtil.demandeToPrtv(demande));
          }
          return insert.then(result => {
            demande.numeroAnfr = result.numeroAnfr;
            demande.checkCode = result.checkCode;
            return {
              step: PRTV_INTERFACE_1,
              updatedDemande: demande
            };
          });
        });
      }
    });
  }
  // si aleatoire
  if (demande.dysfonctionnementInterface.natureDysfonctionnement === PERMANENT_ALEATOIRE.ALEATOIRE) {
    //appel pour avoir la perturbation lte et savoir si c'est un PRTV risque LTE ou non
    let objetAdresse;
    if (demande.accueilInterface2.adresse) {
      objetAdresse = demande.accueilInterface2.adresse;
    }
    const codeInsee = objetAdresse.commune.insee;
    const adresseStruct = deburr(`${objetAdresse.numero || ''} ${objetAdresse.voie} ${objetAdresse.codePostal.codepostal}
     ${objetAdresse.commune.nom}`);
    // appel LTE a 3km
    return AntenneRepository
    .getAntenneLTEPerturbation(codeInsee, adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 3000)
    .then((antennes) => {
      if (antennes.total > 0) {
        //flag PRTV risque LTE
        demande.defaultSuspicionLte = true;
      } else {
        demande.defaultSuspicionLte = false;
      }
      //save/update et go to PRTV
      let insert = null;
      if (demande.numeroAnfr) {
        insert = preUpdatePrtv(demande, DemandeUtil.demandeToPrtv(demande));
      } else {
        insert = prePostPrtv(demande, DemandeUtil.demandeToPrtv(demande));
      }
      return insert.then(result => {
        demande.numeroAnfr = result.numeroAnfr;
        demande.checkCode = result.checkCode;
        return {
          step: PRTV_INTERFACE_1,
          updatedDemande: demande
        };
      });
    });
  }
}

function handleInterventionAntennisteNextStep(demande) {
  // Si oui, on passe a la question suivante
  if (demande.interventionAntenniste.source) {
    return $qProvider().when({
      step: SIGNALEMENT_ANTENNISTE,
      updatedDemande: defaultsDeep({
        interventionAntenniste: {
          source: demande.interventionAntenniste.source
        }
      }, demande)
    });
  } // si  non, type defaut
  return $qProvider().when({
    step: DYSFONCTIONNEMENT_INTERFACE,
    updatedDemande: defaultsDeep({
      interventionAntenniste: {
        source: demande.interventionAntenniste.source
      }
    }, demande)
  });
}

function handleSignalementAntennisteNextStep(demande) {
  demande.defaultSuspicionLte = false;
  //si c'est un brouillage
  let objetAdresse;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  const codeInsee = objetAdresse.commune.insee;
  const adresseStruct = deburr(`${objetAdresse.numero || ''} ${objetAdresse.voie} ${objetAdresse.codePostal.codepostal} ${objetAdresse.commune.nom}`);
  if (demande.signalementAntenniste.natureProbleme === NATURE_PERTURBATION.BROUILLAGE_4G_5G) {
    // appel LTE a 3km.
    return AntenneRepository
    .getAntenneLTEPerturbation(codeInsee, adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 3000)
    .then((antennes) => {
      if (antennes.total > 0) {
        return $qProvider().when({
          step: LTE_INTERFACE_1,
          updatedDemande: defaultsDeep({
            signalementAntenniste: {
              antennes: antennes,
            }
          }, demande)
        });
      } else {
        // appel LTE a 5km
        return AntenneRepository
        .getAntenneLTEPerturbation(codeInsee, adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 5000)
        .then((antennes) => {
          if (antennes.total > 0) {
            return $qProvider().when({
              step: LTE_INTERFACE_1,
              updatedDemande: defaultsDeep({
                signalementAntenniste: {
                  antennes: antennes,
                }
              }, demande)
            });
          } else {
            //PRTV risque LTE
            let insert = null;
            demande.defaultSuspicionLte = true;
            if (demande.numeroAnfr) {
              insert = preUpdatePrtv(demande, DemandeUtil.demandeToPrtv(demande));
            } else {
              insert = prePostPrtv(demande, DemandeUtil.demandeToPrtv(demande));
            }
            return insert.then(result => {
              demande.numeroAnfr = result.numeroAnfr;
              demande.checkCode = result.checkCode;
              return {
                step: PRTV_INTERFACE_1,
                updatedDemande: demande
              };
            });
          }
        });
      }
    });
  } else {
    let insert = null;
    if (demande.numeroAnfr) {
      insert = preUpdatePrtv(demande, DemandeUtil.demandeToPrtv(demande));
    } else {
      insert = prePostPrtv(demande, DemandeUtil.demandeToPrtv(demande));
    }
    // on envoie tjrs une promesse
    return insert.then(result => {
      demande.numeroAnfr = result.numeroAnfr;
      demande.checkCode = result.checkCode;
      return {
        step: PRTV_INTERFACE_1,
        updatedDemande: demande
      };
    });
  }
}

function handleEtatChainesNextStep(demande) {
  const multiplex = demande.accueilInterface2.multiplex;
  const chaines = demande.accueilInterface2.chaines;
  const muxConcernes = filter(multiplex, (m) => m.chainesActives.length && some(m.chainesActives, (c) => some(chaines, (c2) => c.id === c2.id)));

  let objetAdresse;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  const codeInsee = objetAdresse.commune.insee;

  // Vérification de la présence d'un message pour la commune
  if (demande.etatChaines.source === 'oui') {
    return MessageRepository.getMessageCommune(codeInsee)
      .then((messages) => {
        const messageFound = getMessagePourAuMoins(messages.data, muxConcernes, muxConcernes.length);
        if (messageFound) {
          return $qProvider().when({
            step: INCIDENT_DETECTE,
            updatedDemande: defaultsDeep({
              incidentDetecte: {
                message: messageFound
              }
            }, demande)
          });
        }
        //Si aucun message n’est présent, on passe à une question nouvelle sur l’accès à l’antenne
        return $qProvider().when({
          step: ANTENNE_ACCESSIBLE,
          updatedDemande: defaultsDeep({
            aucunIncidentDetecte: {}
          }, demande)
        });
      });
  } // si la source de la commande est 'non' on fait le test pour tout les multiplex
  return MessageRepository.getMessageCommune(codeInsee)
    .then((messages) => {
      const messageFound = getMessagePourAuMoins(messages.data, multiplex, multiplex.length);
      if (messageFound) {
        return $qProvider().when({
          step: INCIDENT_DETECTE,
          updatedDemande: defaultsDeep({
            incidentDetecte: {
              message: messageFound
            }
          }, demande)
        });
      }
      return $qProvider().when({
        step: ANTENNE_ACCESSIBLE,
        updatedDemande: defaultsDeep({
          lteInterface1: {}
        }, demande)
      });
    });
}

function getMessagePourAuMoins(messages, multiplexConcernes, seuil) {
  if (!messages) {
    return null;
  }
  const messagesToReturn = [];
  for (let i = 0; i < messages.length; i++) {
    const message = messages[i];
    // Recherche d'un message qui concerne au moins la moitié des multiplex de la demande
    const nbMultiplexConcernes = countMultiplexCodeInList(message.multiplex, multiplexConcernes);
    if (nbMultiplexConcernes >= seuil) {
      messagesToReturn.push(message);
    }
  }
  if (messagesToReturn.length > 0) {
    return messagesToReturn;
  } else {
    return null;
  }
}

function countMultiplexCodeInList(codes, list) {
  return filter(codes, m => some(list, mc => mc.code === m)).length;
}

function prevStep(demande, currentStep) {
  return $qProvider().when({
    step: prevStepSync(demande, currentStep)
  });
}

function prevStepSync(demande, currentStep) {
  switch (currentStep) {
  case ACCUEIL_INTERFACE_1:
    //au retour on affiche la page "qui etes vous"
    window.localStorage.setItem(FROM_RECLAMATION, true);
    return HOME;
  case SUIVIE_AUTHENT:
    //au retour on affiche la page "vous souhaitez"
    window.localStorage.removeItem(FROM_RECLAMATION);
    return HOME;
  case SUIVIE_RESULTAT:
    return SUIVIE_AUTHENT;
  case HOME:
    return;
  case LTE_INTERFACE_1:
    if (demande.signalementAntenniste && demande.signalementAntenniste.natureProbleme !== '' &&
     demande.signalementAntenniste.natureProbleme !== undefined) {
      return SIGNALEMENT_ANTENNISTE;
    }
    return DYSFONCTIONNEMENT_INTERFACE;
  case ETAT_CHAINES:
    if (demande.reamenagement && demande.reamenagement.source === 'oui') {
      return REAMENAGEMENT;
    }
    return ACCUEIL_INTERFACE_2;
  case ANTENNE_ACCESSIBLE:
    return ETAT_CHAINES;
  case INTERVENTION_ANTENNISTE:
    return ANTENNE_ACCESSIBLE;
  case SIGNALEMENT_ANTENNISTE:
    return INTERVENTION_ANTENNISTE;
  case DYSFONCTIONNEMENT_INTERFACE:
    return INTERVENTION_ANTENNISTE;
  case FIN_ACCUEIL:
    return ANTENNE_ACCESSIBLE;
  case REAMENAGEMENT:
    return ACCUEIL_INTERFACE_2;
  case INCIDENT_DETECTE:
    if (demande.etatChaines && demande.incidentDetecte && demande.incidentDetecte.message) {
      return ETAT_CHAINES;
    }
    if (demande.reamenagement && demande.reamenagement.source === 'oui') {
      return REAMENAGEMENT;
    }
    return ACCUEIL_INTERFACE_2;
  case AUCUN_INCIDENT_DETECTE:
    if (demande.etatChaines && demande.etatChaines.source === 'oui') {
      return ETAT_CHAINES;
    }
    if (demande.reamenagement && demande.reamenagement.source === 'oui') {
      return REAMENAGEMENT;
    }
    return ACCUEIL_INTERFACE_2;
  case CONCLUSION:
    if (demande.typePersonne === TYPE_PERSONNE.PROFESSIONNEL_RECEPTION) {
      return ZONE_PERTURBE;
    }
    if (demande.incidentDetecte && demande.incidentDetecte.message) {
      return INCIDENT_DETECTE;
    }
    if (demande.reamenagement && demande.reamenagement.source === 'fin') {
      return REAMENAGEMENT;
    }
    return AUCUN_INCIDENT_DETECTE;
  case ACCUEIL_INTERFACE_2:
    if (demande.typePersonne === TYPE_PERSONNE.PROFESSIONNEL_RECEPTION) {
      window.localStorage.setItem(FROM_RECLAMATION, true);
      return HOME;
    }
    return ACCUEIL_INTERFACE_1;
  case ACCUEIL_INTERFACE_3:
    return ACCUEIL_INTERFACE_2;
  case CONSTAT:
    return CONTACT;
  case CONTACT:
    if (demande.zonePerturbe && demande.zonePerturbe.source === 'oui') {
      return ZONE_PERTURBE;
    }
    return ACCUEIL_INTERFACE_2;
  case FIN_ANTENNISTE:
    return CONSTAT;
  case PRTV_INTERFACE_1:
    if (demande.aucunIncidentDetecte && demande.aucunIncidentDetecte.continuerPrtv === true) {
      return AUCUN_INCIDENT_DETECTE;
    }
    if (demande.signalementAntenniste && demande.signalementAntenniste.natureProbleme !== '') {
      return SIGNALEMENT_ANTENNISTE;
    }
    if (demande.dysfonctionnementInterface && demande.dysfonctionnementInterface.natureDysfonctionnement !== '') {
      return DYSFONCTIONNEMENT_INTERFACE;
    }
    return INCIDENT_DETECTE;
  case PRTV_INTERFACE_2:
    return PRTV_INTERFACE_1;
  case PRTV_INTERFACE_3:
    return PRTV_INTERFACE_2;
  case PRTV_INTERFACE_4:
    return PRTV_INTERFACE_3;
  case PRTV_INTERFACE_5:
    return PRTV_INTERFACE_4;
  case PRTV_DEPOT_FACTURE:
    return PRTV_INTERFACE_6;
  case PRTV_DEPOT_FACTURE_2:
    return PRTV_DEPOT_FACTURE;
  case LTE_INTERFACE_2:
    return LTE_INTERFACE_1;
  case ZONE_PERTURBE:
    return ACCUEIL_INTERFACE_2;
  default:
    return HOME;
}
}

function allPrevSteps(demande, currentStep) {
  let steps = [];
  if (currentStep) {
    steps = [currentStep];
    let prev = currentStep;
    while (prev !== HOME) {
      prev = prevStepSync(demande, prev);
      steps.push(prev);
    }
  }
  return steps;
}

function normalizeAdresseVoie(adresseDataGouv) {
  let adresseNormalized = '';
  if (adresseDataGouv.type === 'housenumber') {
    adresseNormalized = adresseDataGouv.street;
  } else {
    // Précision : Voie sans numéro
    adresseNormalized = adresseDataGouv.name;
  }

  return minifyNameVoie(adresseNormalized);
}

function renameStCommuneShortName(communeShortName) {
  let communeLongName = communeShortName;
  communeLongName = communeLongName.replace(new RegExp('^ST ', 'ig'), 'SAINT ');
  return communeLongName;
}

function minifyNameVoie(voieLongName) {
  let voieShortName = voieLongName;
  voieShortName = voieShortName.replace(new RegExp('^Allée ', 'ig'), 'ALL ')
    .replace(new RegExp('^Arcade ', 'ig'), 'ARC ')
    .replace(new RegExp('^Autoroute ', 'ig'), 'AUT ')
    .replace(new RegExp('^Avenue ', 'ig'), 'AV ')
    .replace(new RegExp('^Boulevard ', 'ig'), 'BD ')
    .replace(new RegExp('^Bretelle ', 'ig'), 'BRE ')
    .replace(new RegExp('^Carrefour ', 'ig'), 'CAR ')
    .replace(new RegExp('^Chaussée ', 'ig'), 'CHAU ')
    .replace(new RegExp('^Chemin ', 'ig'), 'CHE ')
    .replace(new RegExp('^Chemin Départemental ', 'ig'), 'CD ')
    .replace(new RegExp('^Chemin Rural ', 'ig'), 'CR ')
    .replace(new RegExp('^Chemin Vicinal ', 'ig'), 'CV ')
    .replace(new RegExp('^Corniche ', 'ig'), 'COR ')
    .replace(new RegExp('^Cour ', 'ig'), 'COUR ')
    .replace(new RegExp('^Cours ', 'ig'), 'CRS ')
    .replace(new RegExp('^Coursière ', 'ig'), 'CRsIERE ')
    .replace(new RegExp('^Descente ', 'ig'), 'DSC ')
    .replace(new RegExp('^Déviation ', 'ig'), 'DEVI ')
    .replace(new RegExp('^Escalier ', 'ig'), 'ESC ')
    .replace(new RegExp('^Espace ', 'ig'), 'ESPA ')
    .replace(new RegExp('^Esplanade ', 'ig'), 'ESP ')
    .replace(new RegExp('^Grapillon ', 'ig'), 'GRAP ')
    .replace(new RegExp('^Grimpillon ', 'ig'), 'GRIMP ')
    .replace(new RegExp('^Hameau ', 'ig'), 'HAM ')
    .replace(new RegExp('^Impasse ', 'ig'), 'IMP ')
    .replace(new RegExp('^Jardin ', 'ig'), 'JARD ')
    .replace(new RegExp('^Lieudit ', 'ig'), 'LD ')
    .replace(new RegExp('^Lotissement ', 'ig'), 'LOT ')
    .replace(new RegExp('^Montée ', 'ig'), 'MTE ')
    .replace(new RegExp('^Parc ', 'ig'), 'PARC ')
    .replace(new RegExp('^Passage ', 'ig'), 'PAS ')
    .replace(new RegExp('^Passerelle ', 'ig'), 'PLE ')
    .replace(new RegExp('^Place ', 'ig'), 'PLE ')
    .replace(new RegExp('^Placette ', 'ig'), 'PTTE ')
    .replace(new RegExp('^Pont ', 'ig'), 'PONT ')
    .replace(new RegExp('^Promenade ', 'ig'), 'PROM ')
    .replace(new RegExp('^Quai ', 'ig'), 'QUAI ')
    .replace(new RegExp('^Raidillon ', 'ig'), 'RON ')
    .replace(new RegExp('^Rocade ', 'ig'), 'ROC ')
    .replace(new RegExp('^Rond-Point ', 'ig'), 'RPT ')
    .replace(new RegExp('^Route ', 'ig'), 'RTE ')
    .replace(new RegExp('^Route Départementale ', 'ig'), 'RD ')
    .replace(new RegExp('^Route Nationale ', 'ig'), 'RN ')
    .replace(new RegExp('^Rue ', 'ig'), 'R ')
    .replace(new RegExp('^Ruelle ', 'ig'), 'RLE ')
    .replace(new RegExp('^Ruette ', 'ig'), 'RUET ')
    .replace(new RegExp('^Sentier ', 'ig'), 'SEN ')
    .replace(new RegExp('^Square ', 'ig'), 'SQ ')
    .replace(new RegExp('^Tunnel ', 'ig'), 'TUN ')
    .replace(new RegExp('^Venelle ', 'ig'), 'VEN ')
    .replace(new RegExp('^Viaduc ', 'ig'), 'VIAD ')
    .replace(new RegExp('^Voie ', 'ig'), 'VOIE ')
    .replace(new RegExp('^Voie Communale ', 'ig'), 'VC ')
    .replace(new RegExp('^Voie Nouvelle ', 'ig'), 'VN ')
    .replace(new RegExp('^Professeur ', 'ig'), 'PFR ')
    .replace(new RegExp('^Cardinal ', 'ig'), 'CDL ')
    .replace(new RegExp('^Lieutenant ', 'ig'), 'LT ')
    .replace(new RegExp('^Commandant ', 'ig'), 'CDT ')
    .replace(new RegExp('^Colonel ', 'ig'), 'CEL ')
    .replace(new RegExp('^Général ', 'ig'), 'GAL ')
    .replace(new RegExp('^Docteur ', 'ig'), 'DR ')
    .replace(new RegExp('^Amiral ', 'ig'), 'AM ')
    .replace(new RegExp('^Capitaine ', 'ig'), 'CNE ')
    .replace(new RegExp('^Caporal ', 'ig'), 'CAL ')
    .replace(new RegExp('^Maréchal ', 'ig'), 'MAL ')
    .replace(new RegExp('^Président ', 'ig'), 'PDT ')
    .replace(new RegExp('^Sergent ', 'ig'), 'SGT ')
    .replace(new RegExp('^Saint ', 'ig'), 'Ste ')
    .replace(new RegExp('^Sainte ', 'ig'), 'STE ')
    .replace(new RegExp('^Intérieur ', 'ig'), 'INT ')
    .replace(new RegExp('^Extérieur ', 'ig'), 'EXT ')
    .replace(new RegExp('^Police ', 'ig'), 'POL ')
    .replace(new RegExp('^Résidence ', 'ig'), 'RESID ')
    .replace(new RegExp('^Ancien ', 'ig'), 'ANCE ')
    .replace(new RegExp('^Cimetière ', 'ig'), 'CIM ')
    .replace(new RegExp('^Arrondissement ', 'ig'), 'ARROND ')
    .replace(new RegExp('^Association ', 'ig'), 'ASS ')
    .replace(new RegExp('^Chapelle ', 'ig'), 'CHAP ')
    .replace(new RegExp('^Collège ', 'ig'), 'COLL ')
    .replace(new RegExp('^Domaine ', 'ig'), 'DOM ')
    .replace(new RegExp('^Maternelle ', 'ig'), 'MATER ')
    .replace(new RegExp('^Eglise ', 'ig'), 'EGL ')
    .replace(new RegExp('^Gendarmerie ', 'ig'), 'GEND ')
    .replace(new RegExp('^Quartier ', 'ig'), 'QUART ')
    .replace(new RegExp('^Lotissement ', 'ig'), 'LOT ');
  return voieShortName;
}

function unminifyNameVoie(voieShortName) {
  let voieLongName = voieShortName;
  voieLongName = voieLongName.replace(new RegExp('^ALL ', 'ig'), 'Allée ')
    .replace(new RegExp('^ARC ', 'ig'), 'Arcade ')
    .replace(new RegExp('^AUT ', 'ig'), 'Autoroute ')
    .replace(new RegExp('^AV ', 'ig'), 'Avenue ')
    .replace(new RegExp('^BAD ', 'ig'), 'Boulevard ')
    .replace(new RegExp('^BRE ', 'ig'), 'Bretelle ')
    .replace(new RegExp('^CAR ', 'ig'), 'Carrefour ')
    .replace(new RegExp('^CHAU ', 'ig'), 'Chaussée ')
    .replace(new RegExp('^CHE ', 'ig'), 'Chemin ')
    .replace(new RegExp('^CD ', 'ig'), 'Chemin Départemental ')
    .replace(new RegExp('^CR ', 'ig'), 'Chemin Rural ')
    .replace(new RegExp('^CV ', 'ig'), 'Chemin Vicinal ')
    .replace(new RegExp('^COR ', 'ig'), 'Corniche ')
    .replace(new RegExp('^COUR ', 'ig'), 'Cour ')
    .replace(new RegExp('^CRS ', 'ig'), 'Cours ')
    .replace(new RegExp('^CRsIERE ', 'ig'), 'Coursière ')
    .replace(new RegExp('^DSC ', 'ig'), 'Descente ')
    .replace(new RegExp('^DEVI ', 'ig'), 'Déviation ')
    .replace(new RegExp('^ESC ', 'ig'), 'Escalier ');
  return voieLongName;
}

export {
  STEPS,
  FROM_RECLAMATION,
  validateDemandeForStep,
  nextStep,
  prevStep,
  allPrevSteps,
  prePostPrtv,
  preUpdatePrtv
};



// WEBPACK FOOTER //
// ./src/utils/routes.util.js